// @core/api/endpoints/legalentity/create_legal_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateLegalEntityRequest,
  LegalEntityResponse,
} from '../../../types/legalentity';

const BASE_PATH = '/legalentity';

/**
 * Create a legal entity
 * Creates a new legal entity record under the current tenant. Multiple legal entities per tenant are allowed (holding companies, multi-jurisdiction operations). Initial status is DRAFT until requisites are verified against an external registry.
 */
export async function CreateLegalEntity(
  data: CreateLegalEntityRequest,
  options?: RequestOptions
): Promise<LegalEntityResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/`;
  const requestOptions = options;
  return client.post<LegalEntityResponse>(requestPath, data, requestOptions);
}
